//lib
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

//src
import { useAuth } from "../../context/AuthContext";
import { CardStyled, FeatureSelectionStyled } from "./feature-selection.style";
import Hello from "../../images/Frame.png"
import { ClockIcon, ProjectsIcon } from "../../utils/svg-components";
import Timesheets from "../../images/timesheets.png"
import PList from "../../images/pList.png"

const FeatureSelection = () => {
  const { userDetails } = useAuth();
  const [currentDate, setCurrentDate] = useState("");

  const navigate = useNavigate();
  const onTrackTime = () => {
    navigate("/time-tracker/");
  };
  const onProjectsList = () => {
    navigate("/projectsview/");
  };

  useEffect(() => {
    // Initialize the current date only once when the component mounts
    const today = new Date();
    const options = { weekday: "long", month: "long", day: "numeric" };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      today
    );
    setCurrentDate(formattedDate);
  }, []);

  return (
    <FeatureSelectionStyled>
      <div className="widget-content">
        <CardStyled className="user">
          <div>
          <Typography variant="h5">{currentDate}</Typography>
            <Typography variant="h4">
              Welcome back, {userDetails?.fullName}
            </Typography>
          </div>

          <div className="date">
            <img src={Hello}></img>
            </div>
        </CardStyled>

        <div className="feature-tiles">
          <CardStyled className="flex timesheet" onClick={onTrackTime}>
            <div className="time">
            <div className="icon">
            <ClockIcon size={40} />
            <Typography variant="h1">Timesheets</Typography>
            </div>
            <Typography
              variant="h5"
              className="corner"
              sx={{ ":hover": { opacity: 0.8 } }}
            >
              Track your time 
            </Typography>
            </div>
            <div className="img">
            <img src={Timesheets}></img>
            </div>
          </CardStyled>

          <CardStyled className="flex projectList" onClick={onProjectsList}>
            <div className="list">
            <div className="icon">
            <ProjectsIcon size={40} />
            <Typography variant="h1">Project List</Typography>
            </div>
            <Typography
              variant="h5"
              className="corner"
              sx={{ ":hover": { opacity: 0.8 } }}
            >
              See all projects
            </Typography>
            </div>
            <div className="img">
            <img src={PList}></img>
            </div>
          </CardStyled>
        </div>
      </div>
    </FeatureSelectionStyled>
  );
};

export default FeatureSelection;
